import angular from 'angular'

import templateUrl from './edit-rs-schedule.component.html'

export const EditRSScheduleComponent = {
    templateUrl,
    controller: EditRSScheduleController,
    controllerAs: "vm",
    bindings: {
        rsScheduleID: "<rsScheduleId"
    }
}

function EditRSScheduleController(rsScheduleService, utilityService) {
    'ngInject'
    const vm = this;

    vm.rsScheduleID;
    vm.pristineSchedule;
    vm.rsSchedule;
    vm.init = $onInit;
    vm.locked = false;
    vm.handleSave = handleSave;
    vm.handleCancel = handleCancel;
    vm.$onInit = $onInit;

    function $onInit() {
        vm.loaded = false;
        utilityService.showLoading();

        loadRSSchedule(vm.rsScheduleID)
            .then(function () {
                utilityService.hideLoading();
                vm.loaded = true;
            });
    }

    function loadRSSchedule(rsScheduleID) {
        return rsScheduleService.retrieveRSSchedule(rsScheduleID)
            .then(function (rsSchedule) {
                vm.pristineSchedule = rsSchedule;
                vm.rsSchedule = angular.copy(vm.pristineSchedule);
                vm.locked = rsSchedule.RSScheduleSales.reduce(function (locked, sales) {
                    return locked || sales.Locked;
                }, false);
            })
            .catch(function (ex) {
                alert("Loading the schedule failed. " + ex);
            });
    }

    function handleSave() {
        if (vm.editForm.$valid) {
            vm.editForm.$setSubmitted();
            rsScheduleService
                .updateRSSchedule(vm.rsSchedule)
                .then(function () {
                    vm.pristineSchedule = angular.copy(vm.rsSchedule);
                    vm.editForm.$setPristine();
                })
                .catch(function () {
                    vm.editForm.$setPristine();
                    vm.editForm.$setDirty();
                    alert("Saving failed.")
                });
        }
    }

    function handleCancel() {
        vm.rsSchedule = angular.copy(vm.pristineSchedule);
        vm.editForm.$setPristine();

        window.location.href = "RSSchedule/ListRSSchedules";
    }
}
